import Activity from 'actions/activity';

export default Activity.createReducer();